import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, TrendingUpIcon, PauseCircleIcon, UsersIcon, BackpackIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ReviewsGallery } from '../components/ReviewsGallery';
import { EnrollmentOffer } from '../components/EnrollmentOffer';
import { FAQSection } from '../components/FAQSection';
export function Course6Page() {
  const modules = [{
    id: '01',
    title: 'Cum să măsori progresul corect',
    icon: <TrendingUpIcon size={48} className="text-brand-gold" data-id="element-925" />,
    bullets: ['De ce nu trebuie să compari copilul tău cu alții, ci cu el însuși', 'Cum să folosești "Jurnalul de Progres" pentru a vedea micile victorii', 'Semne că metodele pe care le aplici funcționează']
  }, {
    id: '02',
    title: 'Când lucrurile stagnează',
    icon: <PauseCircleIcon size={48} className="text-brand-gold" data-id="element-926" />,
    bullets: ['De ce apar platourile în dezvoltare și de ce sunt normale', 'Cum să ajustezi așteptările și tehnicile când simți că "nu mai funcționează"', 'Cum să eviți epuizarea maternă (burnout-ul) în perioadele dificile']
  }, {
    id: '03',
    title: 'Când și cum să ceri ajutor profesional',
    icon: <UsersIcon size={48} className="text-brand-gold" data-id="element-927" />,
    bullets: ['Semne clare că intervenția acasă nu mai este suficientă', 'Cum să alegi specialistul potrivit (logoped, terapeut ABA, psiholog)', 'Cum să colaborezi eficient cu echipa de specialiști']
  }, {
    id: '04',
    title: 'Pregătirea pentru grădiniță',
    icon: <BackpackIcon size={48} className="text-brand-gold" data-id="element-928" />,
    bullets: ['Cum știi dacă copilul tău este pregătit pentru grădiniță', 'Cum să faci acomodarea mai ușoară', 'Cum să comunici eficient cu educatoarea despre nevoile copilului tău']
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-929">
      {/* SECȚIUNEA 1 — HERO OFERTĂ */}
      <section className="bg-brand-navy section-padding text-white" data-id="element-930">
        <div className="container-custom" data-id="element-931">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-932">
            <div className="max-w-xl" data-id="element-933">
              <h1 className="font-playfair text-[48px] md:text-[64px] font-bold text-white mb-6 leading-[1.1]" data-id="element-934">
                Re-evaluare și Următorii Pași
              </h1>
              <p className="font-source text-[20px] md:text-[24px] text-brand-gold mb-10 italic" data-id="element-935">
                Învață cum să măsori progresul, să ajustezi planul și să știi
                exact când ești pe drumul cel bun și când ai nevoie de ajutor.
              </p>
              <a href="#inscriere" className="btn-inverted text-[18px] px-8 py-4" data-id="element-936">
                Click aici pentru înscriere!
              </a>
            </div>
            <div className="relative rounded-[24px] overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-937">
              <img src="https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf3360b818c92b36638c4.jpg" alt="Re-evaluare și Următorii Pași" className="w-full h-full object-cover aspect-[4/3]" data-id="element-938" />
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — DESCRIERE */}
      <section className="bg-brand-beige section-padding" data-id="element-939">
        <div className="container-custom" data-id="element-940">
          <div className="max-w-3xl mx-auto" data-id="element-941">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy mb-8 text-center" data-id="element-942">
              Ești pe drumul cel bun sau ai nevoie de ajutor suplimentar?
            </h2>
            <div className="font-source text-[16px] md:text-[18px] text-brand-text space-y-6" data-id="element-943">
              <p data-id="element-944">
                Ai început să aplici tehnici acasă, ai schimbat modul în care
                comunici și te joci cu copilul tău. Poate ai văzut primele
                rezultate, dar acum simți că lucrurile au stagnat. Sau poate te
                pregătești pentru o schimbare majoră, cum ar fi intrarea la
                grădiniță, și te întrebi dacă copilul tău este cu adevărat
                pregătit.
              </p>
              <p data-id="element-945">
                Dezvoltarea unui copil nu este o linie dreaptă. Există salturi,
                dar există și platouri sau chiar regresii temporare. Fără un
                sistem clar de a măsura progresul, riști să te descurajezi prea
                repede sau, dimpotrivă, să ratezi momentul în care intervenția
                unui specialist devine necesară.
              </p>
              <div className="bg-white p-6 rounded-[16px] border-l-4 border-brand-coral" data-id="element-946">
                <p className="font-medium text-brand-navy" data-id="element-947">
                  Cursul "C - Re-evaluare și Următorii Pași" este busola ta pe
                  termen lung. Te învață cum să fii obiectivă în privința
                  progresului copilului tău, cum să ajustezi tehnicile când nu
                  mai funcționează și cum să iei cele mai bune decizii pentru
                  viitorul lui, inclusiv integrarea în colectivitate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — CE VEI DESCOPERI */}
      <section className="bg-brand-ivory section-padding" data-id="element-948">
        <div className="container-custom" data-id="element-949">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-16" data-id="element-950">
            Ce vei descoperi concret în Cursul 6: Re-evaluare și Următorii Pași
          </h2>
          <div className="max-w-4xl mx-auto space-y-8" data-id="element-951">
            {modules.map(mod => <div key={mod.id} className="flex flex-col md:flex-row bg-white rounded-[24px] shadow-sm border border-gray-100 overflow-hidden p-8 gap-8 items-start" data-id="element-952">
                {/* Icon Side */}
                <div className="flex-shrink-0 w-24 h-24 rounded-full bg-brand-beige flex items-center justify-center" data-id="element-953">
                  {mod.icon}
                </div>

                {/* Content Side */}
                <div className="flex-grow" data-id="element-954">
                  <h3 className="font-playfair text-[24px] md:text-[28px] font-bold text-brand-navy mb-6 leading-[1.2]" data-id="element-955">
                    {mod.title}
                  </h3>
                  <ul className="space-y-4 flex flex-col" data-id="element-956">
                    {mod.bullets.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-957">
                        <CheckCircle2Icon className="text-brand-gold flex-shrink-0 mt-1" size={20} data-id="element-958" />
                        <span className="font-source text-[15px] text-brand-text" data-id="element-959">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — BENEFICII */}
      <section className="bg-brand-beige section-padding" data-id="element-960">
        <div className="container-custom" data-id="element-961">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-962">
            Ce se schimbă după ce parcurgi acest curs
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-963">
            {[{
            title: 'Ai claritate asupra progresului',
            desc: 'Nu te mai bazezi pe "mi se pare că". Ai instrumente clare pentru a măsura progresul real al copilului tău.'
          }, {
            title: 'Știi ce să faci când te blochezi',
            desc: 'Nu te mai panichezi când lucrurile stagnează. Ai un plan de rezervă și știi cum să ajustezi tehnicile.'
          }, {
            title: 'Iei decizii informate despre specialiști',
            desc: 'Nu mai pierzi timp și bani cu terapii nepotrivite. Știi exact când ai nevoie de ajutor și pe cine să cauți.'
          }, {
            title: 'Faci tranziția la grădiniță mai ușoară',
            desc: 'Ești pregătită pentru următoarea mare etapă din viața copilului tău și știi cum să-l susții.'
          }].map((card, i) => <div key={i} className="bg-white p-6 rounded-[16px] shadow-sm border-t-4 border-brand-gold" data-id="element-964">
                <h3 className="font-montserrat font-bold text-[16px] text-brand-navy mb-3" data-id="element-965">
                  {card.title}
                </h3>
                <p className="font-source text-[14px] text-brand-text" data-id="element-966">
                  {card.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 5 — CINE SUNT EU */}
      <section className="bg-brand-ivory section-padding" data-id="element-967">
        <div className="container-custom" data-id="element-968">
          <div className="max-w-4xl mx-auto" data-id="element-969">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-10" data-id="element-970">
              Cine sunt eu și de ce am creat acest curs
            </h2>
            <div className="flex flex-col-reverse md:grid md:grid-cols-3 gap-8 items-stretch" data-id="element-971">
              <div className="md:col-span-2 font-source text-[16px] md:text-[18px] text-brand-text space-y-4 text-center md:text-left flex flex-col justify-center" data-id="element-972">
                <p data-id="element-973">
                  Sunt Cristina Geană, psiholog clinician cu peste 11 ani de
                  experiență directă cu copii mici. Am însoțit sute de familii
                  pe drumul dezvoltării și știu că acest drum nu este niciodată
                  liniar.
                </p>
                <p data-id="element-974">
                  Am creat acest curs pentru a-ți oferi o hartă clară pentru
                  momentele în care te simți pierdută, pentru a ști cum să
                  măsori succesul și cum să te pregătești pentru viitor.
                </p>
              </div>
              <div className="md:col-span-1" data-id="element-975">
                <img src="https://cdn.magicpatterns.com/uploads/wvUBHAy6VhqaRqNiVJPB6X/Cristina_poze_%285%29.jpg" alt="Cristina Geană" className="w-full h-full object-cover object-top rounded-[24px] shadow-card" data-id="element-976" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="bg-brand-navy section-padding text-white" data-id="element-977">
        <div className="container-custom" data-id="element-978">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white text-center mb-12" data-id="element-979">
            Pentru cine este acest curs?
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-980">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-[24px] border border-white/20" data-id="element-981">
              <h3 className="font-playfair text-[28px] font-bold text-brand-gold mb-6 !text-brand-gold" data-id="element-982">
                Pentru cine este
              </h3>
              <ul className="space-y-4" data-id="element-983">
                {['Mame care au aplicat tehnici acasă și vor să știe cum să măsoare progresul', 'Mame care simt că au ajuns la un platou și nu știu cum să continue', 'Mame care se pregătesc pentru intrarea copilului în colectivitate (grădiniță)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-984">
                    <CheckCircle2Icon className="text-brand-gold flex-shrink-0 mt-0.5" size={20} data-id="element-985" />
                    <span className="font-source text-[15px] text-white/90" data-id="element-986">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-white/5 p-8 rounded-[24px] border border-white/10" data-id="element-987">
              <h3 className="font-playfair text-[28px] font-bold text-white mb-6 !text-white" data-id="element-988">
                Pentru cine NU este
              </h3>
              <ul className="space-y-4" data-id="element-989">
                {['Mame care nu au parcurs și aplicat informațiile din celelalte cursuri CRESC', 'Mame care caută pe cineva care să ia deciziile în locul lor', 'Profesioniști care caută un curs de specialitate. Acest curs e pentru mame, în limbaj accesibil.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-990">
                    <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-991">
                      <span className="w-1.5 h-1.5 rounded-full bg-white/60" data-id="element-992"></span>
                    </div>
                    <span className="font-source text-[15px] text-white/70" data-id="element-993">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 7 — OFERTĂ */}
      <EnrollmentOffer title="Ce primești și care este investiția ta" includes={['Acces pe viață la Modulul 6 - Re-evaluare și Următorii Pași', 'Materiale video structurate pas cu pas', 'Tehnici practice de aplicat acasă', 'Informație clară, fără termeni medicali']} price="395 lei" note="Acest modul face parte din Colecția Completă Uite cum C.R.E.S.C., dar poate fi achiziționat și separat." data-id="element-994" />

      {/* SECȚIUNEA 8 — TESTIMONIALE */}
      <section className="bg-brand-ivory section-padding" data-id="element-995">
        <div className="container-custom" data-id="element-996">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-997">
            Ce spun mamele care deja au lucrat cu mine
          </h2>
          <ReviewsGallery data-id="element-998" />
        </div>
      </section>

      {/* SECȚIUNEA 9 — FAQ */}
      <FAQSection faqs={[{
      q: 'Când primesc acces la curs?',
      a: 'Imediat după confirmarea plății, vei primi pe email datele de acces la platforma unde se află cursul.'
    }, {
      q: 'Cât timp am acces la materiale?',
      a: 'Ai acces pe viață la acest modul. Îl poți revedea ori de câte ori ai nevoie, în ritmul tău.'
    }, {
      q: 'Pot cumpăra și restul modulelor mai târziu?',
      a: 'Da, poți achiziționa celelalte module separat sau poți opta pentru Colecția Completă C.R.E.S.C. pentru a beneficia de prețul special și de apelurile de grup.'
    }]} data-id="element-999" />

      {/* SECȚIUNEA 10 — ÎNSCRIERE */}
      <section id="inscriere" className="bg-brand-navy section-padding text-center text-white" data-id="element-1000">
        <div className="container-custom" data-id="element-1001">
          <div className="max-w-3xl mx-auto" data-id="element-1002">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white mb-6" data-id="element-1003">
              Înscriere Modulul 6 - Re-evaluare și Următorii Pași
            </h2>
            <p className="font-source text-[18px] text-white/80 mb-8" data-id="element-1004">
              Completează formularul de mai jos pentru a finaliza înscrierea.
            </p>

            <div className="bg-white rounded-[24px] overflow-hidden min-h-[600px]" data-id="element-1005">
              <iframe src="https://api.leadconnectorhq.com/widget/form/3O8JRlvpYmmtQvlGYIDi" style={{
              width: '100%',
              height: '100%',
              minHeight: '600px',
              border: 'none'
            }} id="inline-3O8JRlvpYmmtQvlGYIDi" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Form Modul 6" data-height="600" data-layout-iframe-id="inline-3O8JRlvpYmmtQvlGYIDi" data-form-id="3O8JRlvpYmmtQvlGYIDi" title="Form Modul 6" data-id="element-1006" />
            </div>
          </div>
        </div>
      </section>
    </motion.div>;
}